import { render, staticRenderFns } from "./payment-name.vue?vue&type=template&id=cc1a40a6"
import script from "./payment-name.vue?vue&type=script&lang=ts"
export * from "./payment-name.vue?vue&type=script&lang=ts"
import style0 from "./payment-name.vue?vue&type=style&index=0&id=cc1a40a6&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\dev\\eatself\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cc1a40a6')) {
      api.createRecord('cc1a40a6', component.options)
    } else {
      api.reload('cc1a40a6', component.options)
    }
    module.hot.accept("./payment-name.vue?vue&type=template&id=cc1a40a6", function () {
      api.rerender('cc1a40a6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/payment-name.vue"
export default component.exports